export const moduleId = 'summary';
